import LaunchDynamicInsightsTable from './Table';
export default LaunchDynamicInsightsTable;
